
import Login from "../landingpage/Login.vue";
import { Carousel, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import { computed, ComputedRef, onBeforeMount, Ref } from "vue";
import { useStore } from "vuex";
import "./callCarousel.css";
import Card from "./Card.vue";
import LoginForm from "../application/forms/LoginForm.vue";
import { defineComponent, ref } from "@vue/runtime-core";
import RegisterModal from "./RegisterModal.vue";
import { disableBodyOverflow, enableBodyOverflow } from "../mixins";
import { Course } from "../../../../domain/entities/entities";
import { useRoute } from "vue-router";
import { dispatchError } from "../../utils/error_handling";

const __default__ = defineComponent({
  components: {
    RegisterModal,
    LoginForm,
    Card,
    login: Login,
    Carousel,
    Slide,
    Navigation
  },

  setup() {
    const route = useRoute();
    const store = useStore();

    const loginDisplay: Ref<string> = ref("none");

    const newsCourses: ComputedRef<Course[]> = computed(() => {
      return store.getters["course_module/courses"] || [];
    });

    const isModalOpened: Ref<boolean> = ref(false);

    onBeforeMount(async () => {
      if (route.query?.redirect) loginDisplay.value = "flex";

      await loadNewsCourses();
    });
    /* make registration pop-up visible when called */
    function showRegistrationSpan(): void {
      store.dispatch("setRegistrationSpanVisibility", true);
    }

    function formattedDuration(duration: number) {
      const sec = duration;
      let hours: string | number = Math.floor(sec / 3600);
      let minutes: string | number = Math.floor((sec - hours * 3600) / 60);
      let seconds: string | number = sec - hours * 3600 - minutes * 60;
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      if (hours > 24) {
        return hours + "h";
      }
      if (hours == 0) {
        return minutes + ":" + seconds + "m";
      }
      return hours + ":" + minutes + ":" + seconds + "h";
    }

    async function loadNewsCourses(): Promise<void> {
      try {
        await store.dispatch("course_module/loadNewsCourses");
      } catch (e) {
        await dispatchError(e);
      }
    }

    const toggleLogin = (): void => {
      console.log("oi");
      loginDisplay.value = loginDisplay.value === "none" ? "flex" : "none";
      if (loginDisplay.value === "flex") {
        disableBodyOverflow();
      } else {
        enableBodyOverflow();
      }
    };

    const toggleRegisterModal = async (): Promise<void> => {
      isModalOpened.value = !isModalOpened.value;
      await store.dispatch("authentication_module/clearPasswordStrength");
    };

    return {
      newsCourses,
      isModalOpened,
      loginDisplay,
      toggleRegisterModal,
      showRegistrationSpan,
      loadNewsCourses,
      formattedDuration,
      toggleLogin
    };
  }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "1287294c": (_ctx.loginDisplay)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__